/**
 * Parses search params to `URLSearchParams`. This also converts non-strings
 * into strings.
 *
 * @param searchParams The search params.
 */
export function appSearchParamsToURLSearchParams(searchParams) {
    return Object.keys(searchParams).reduce((search, paramName) => {
        const paramValue = searchParams[paramName];
        if (typeof paramValue !== 'undefined') {
            const values = paramValue instanceof Array ? paramValue : [paramValue];
            values.forEach((value) => search.append(paramName, value.toString()));
        }
        return search;
    }, new URLSearchParams());
}
/**
 * Parses a location search string to serializable search params. The consumer
 * would then in turn have to do any further processing to convert some of these
 * values into their proper types. For example, the string 'true' might need to
 * be converted to the boolean `true`.
 *
 * @param searchString The search string.
 */
export function appSearchStringToParams(searchString) {
    return [...new URLSearchParams(searchString).entries()].reduce((params, [name, value]) => {
        const param = params[name];
        return Object.assign(Object.assign({}, params), { [name]: 
            // Do an explicit undefined check because the value might be an empty
            // string and we want to preserve that.
            typeof param !== 'undefined'
                ? param instanceof Array
                    ? [...param, value]
                    : [param, value]
                : value });
    }, {});
}
